module.exports = __webpack_public_path__ + "img/prosearch.bdf1ee85.png";